import { render, staticRenderFns } from "./DrawMenu.vue?vue&type=template&id=8209d40e&scoped=true&"
import script from "./DrawMenu.vue?vue&type=script&lang=js&"
export * from "./DrawMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8209d40e",
  null
  
)

export default component.exports